// Components
import SpMenu from './components/SpMenu/SpMenu';
import Emergence from './components/Emergence/Emergence';
import GoogleMap from './components/GoogleMap/GoogleMap';
import Accordion from './components/Accordion/Accordion';
import {initPageScroll} from './components/PageScroll/PageScroll';

// Page
import frontPage from './page/FrontPage';
import archivePage from './page/ArchivePage';
import contactPage from './page/ContactPage';
import sectionHeading from './components/SectionHeading/SectionHeading';

// promise test
// import p from './promise_test/_4';
// p();

/**
 * Components
 * 各ページ共通で使用される可能性がある
 */
Emergence();
GoogleMap();
initPageScroll();
sectionHeading();
archivePage();
contactPage();
const accordion = new Accordion(".js-accordion-btn");
const spMenu = new SpMenu(".js-spMenu");


/**
 * Page
 * ページ単一で使用される
 */
function isBodyClass(className) {
  const name = className.replace( "." , "" ) ;
  return document.body.classList.contains(name);
}
switch(true) {
  case isBodyClass('.p-front-page'):
    frontPage();
    break;
  default:
    break;
}